/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

import { get, writable } from 'svelte/store';
import { getTenantConfiguration } from '@/services/tenantConfigurationService';
import { extractSubdomain } from '@/core/utils';
import { launchAuthoring } from '@/services/ltiService';

export const currentTenantStore = writable(null);

function createConfigurationStore() {
    const configurationStore = writable(null);

    return {
        get() {
            return get(configurationStore);
        },
        set: configurationStore.set,
        subscribe: configurationStore.subscribe,
        clear: () => configurationStore.set(null),
        setCurrentTenant(tenant) {
            currentTenantStore.set(tenant);
        },
        getCurrentTenant() {
            return get(currentTenantStore);
        },
        isAutomaticSessionSelectionEnabled() {
            const configuration = get(configurationStore);
            return configuration?.automaticSessionSelection;
        },
        isMinimalUITestTakerEnabled() {
            const configuration = get(configurationStore);
            return configuration?.minimalUITestTaker;
        },
        async updateConfigurationData() {
            const subdomain = extractSubdomain(window.location.href);
            const { configuration = {} } = await getTenantConfiguration(subdomain);

            configuration.slugs = {
                ...configuration.slugs,
                default: {
                    session: 'matter_and_measurements',
                    testTaker: 'matter_and_measurements_test_taker',
                    dashboard: 'progress_monitoring_dashboard',
                    student: 'test_taker_report',
                    ...configuration.slugs?.default
                }
            };

            configurationStore.set(configuration);
        },
        async getContentBankUrl() {
            const configuration = get(configurationStore);
            if (this.isAuthoringSSOEnabled()) {
                const location = window.location;
                return (await launchAuthoring(location.href, `${location.origin}/logout`, location.origin))
                    .ltiLaunchLink;
            }

            if (configuration.authoringUrl) {
                return configuration.authoringUrl;
            }

            return '#';
        }
    };
}

export const configurationStore = createConfigurationStore();
